export const GET_VENDOR_AND_BOXIGO_MARGIN = "GET_VENDOR_AND_BOXIGO_MARGIN";
export const CREATE_VENDOR_AND_BOXIGO_MARGIN = "CREATE_VENDOR_AND_BOXIGO_MARGIN";
export const UPDATE_VENDOR_AND_BOXIGO_MARGIN = "UPDATE_VENDOR_AND_BOXIGO_MARGIN";